import { render, staticRenderFns } from "./MainPropsCategory.vue?vue&type=template&id=209354bc&scoped=true"
import script from "./MainPropsCategory.vue?vue&type=script&lang=js"
export * from "./MainPropsCategory.vue?vue&type=script&lang=js"
import style0 from "./MainPropsCategory.vue?vue&type=style&index=0&id=209354bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209354bc",
  null
  
)

export default component.exports